import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'kzn-layout-before-login',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './layout-before-login.component.html',
  styleUrl: './layout-before-login.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LayoutBeforeLoginComponent {

}
